<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22.432" height="22.433" viewBox="0 0 22.432 22.433">
    <g id="Сгруппировать_4767" data-name="Сгруппировать 4767" transform="translate(0)">
      <g id="Сгруппировать_4766" data-name="Сгруппировать 4766" transform="translate(0 0)">
        <path id="Контур_4051" data-name="Контур 4051" d="M-1688.2-574.931a11.216,11.216,0,0,0-11.216,11.216A11.217,11.217,0,0,0-1688.2-552.5a11.217,11.217,0,0,0,11.217-11.216A11.217,11.217,0,0,0-1688.2-574.931Zm4.849,13.349h-4.755c-.016,0-.031,0-.047,0s-.031,0-.047,0a.776.776,0,0,1-.776-.776v-7.919a.776.776,0,0,1,.776-.776.776.776,0,0,1,.776.776v7.143h4.073a.776.776,0,0,1,.776.776A.776.776,0,0,1-1683.349-561.582Z" transform="translate(1699.414 574.931)" fill="#e1cd9d"/>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconClocks',
  }
</script>
